<div class="circle" [ngStyle]="{'background-color':  circleColor }">
	<img *ngIf="!showInitials" src="{{photoUrl}}">

	<div *ngIf="showInitials" class="initials">
		{{ initials }}
	</div>
	<span *ngIf="photoUrl && puedeEliminar" class="badge badge-primary avatar-close" title="Eliminar" (click)="eliminar($event)">x</span>
</div>
